// Firebase Token 管理器
class FirebasetokenManager {
  private token: string | null = null
  private updateToken: boolean = false
  private firebaseProjectId: string | null = null

  // 设置 token
  setToken(token: string) {
    this.token = token
  }

  // 获取 token
  getToken(): string | null {
    return this.token
  }

  // 清除 token
  clearToken() {
    this.token = null
  }

  // 检查是否有 token
  hasToken(): boolean {
    return !!this.token
  }

  // 设置更新 token 标志
  setUpdateToken(update: boolean) {
    this.updateToken = update
  }

  // 获取更新 token 标志
  getUpdateToken(): boolean {
    return this.updateToken
  }

  // 设置 Firebase 项目 ID
  setFirebaseProjectId(projectId: string) {
    this.firebaseProjectId = projectId
  }

  // 获取 Firebase 项目 ID
  getFirebaseProjectId(): string | null {
    return this.firebaseProjectId
  }
}

export default new FirebasetokenManager()
